import ColorfulTable from './colorful-table';
export default ColorfulTable;
